import { render, staticRenderFns } from "./closeOnClickModal-editor.vue?vue&type=template&id=31d7e159&scoped=true&"
import script from "./closeOnClickModal-editor.vue?vue&type=script&lang=js&"
export * from "./closeOnClickModal-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d7e159",
  null
  
)

export default component.exports